import { GlobalGridOptions } from './global-grid-options';
export class SlickgridConfig {
    constructor() {
        this.options = GlobalGridOptions;
    }
}
//# sourceMappingURL=slickgrid-config.js.map